import React, { useState } from 'react';
import './index.css';
import { Dropdown } from 'react-bootstrap';
import FormControlLabel from '@mui/material/FormControlLabel';
import { CustomRadioButton } from './index';

const CustomToggle = React.forwardRef(({ isToggled, onClick }, ref) => {
    const imageClass = isToggled ? "notificationFilterActive" : "notificationFilter";
    return (
        <div className={imageClass}
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }} />
    );
});

const Circle = ({ isChecked=false }) => {
    return <div style={{ marginLeft: 12 }}><CustomRadioButton isChecked={isChecked} /></div>;
};

const DropItem = React.forwardRef(({ label, value, selectedValue, onClick }, ref) => {
    const isChecked = value === selectedValue;
    return (
        <FormControlLabel
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
            className="filterDropdownItem"
            style={{ 
                alignSelf: 'flex-end', 
                padding: 0, 
                paddingRight: 0, 
                margin: 0, 
                width: '100%' 
            }}
            label={label}
            control={<Circle isChecked={isChecked} />}
            labelPlacement="start" 
        />
    );
});

export const FilterDropdown = ({ selectedValue="", width=200, onChange=null }) => {
    const [isToggled, setIsToggled] = useState(false);
    
    return (
        <Dropdown onToggle={e => setIsToggled(e)} onSelect={(e) => onChange(e)}>
            <Dropdown.Toggle
                as={CustomToggle}
                isToggled={isToggled}
                id="dropdown-custom-components" 
            />
            <Dropdown.Menu 
                className="dropdownConfig" 
                align="end" // Updated from alignRight
                style={{ width: width, padding: 0 }}
            >
                <Dropdown.Item as={DropItem} value="all" eventKey="all" label="All Notifications" selectedValue={selectedValue} />
                <Dropdown.Item as={DropItem} value="broadcast" eventKey="broadcast" label="All School" selectedValue={selectedValue} />
                <Dropdown.Item as={DropItem} value="school" eventKey="school" label="Grades & Divisions" selectedValue={selectedValue} />
                <Dropdown.Item as={DropItem} value="student" eventKey="student" label="Student ID" selectedValue={selectedValue} />
            </Dropdown.Menu>
        </Dropdown>
    );
};